import createSagaMiddleware from 'redux-saga';
import chartsMiddleware from '../pages/ProjectsPage/middleware/ProjectsPage';
import packagesMiddleware from '../pages/PackagesPage/middleware/PackagesPage';

const sagaMiddleware = createSagaMiddleware({});

export function init() {
  sagaMiddleware.run(chartsMiddleware);
  sagaMiddleware.run(packagesMiddleware);
}

export default sagaMiddleware;
